'use strict';

export default class AreaChart {
  constructor(d3, id, dataset, lbl1, lbl2) {
    const width = 400;
    const height = 200;

    const margin = {
      top: 20,
      right: 0,
      bottom: 30,
      left: -1
    };

    const x = d3
      .scaleLinear()
      .domain([5, 23])
      .range([margin.left, width - margin.right]);

    const y = d3
      .scaleLinear()
      .domain([0, d3.max(dataset, d => d.handleTimeAvg) + 2])
      .nice()
      .range([height - margin.bottom, margin.top]);

    const yPersonal = d3
      .scaleLinear()
      .domain([0, d3.max(dataset, d => d.handleTimeAvg)])
      .nice()
      .range([height - margin.bottom, margin.top]);

    const xAxis = g =>
      g
        .attr('class', 'graph-axis')
        .attr('transform', `translate(0, ${height - margin.bottom})`)
        .call(
          d3
            .axisBottom(x)
            .tickFormat(hr => (hr > 12 ? `${hr - 12}pm` : `${hr}am`))
            .tickSize(-height)
        );

    const avgTimeArea = d3
      .area()
      .x(d => x(d.time))
      .y0(y(0))
      .y1(d => y(d.handleTimeAvg))
      .curve(d3.curveMonotoneX);

    const personalTimeArea = d3
      .area()
      .x(d => x(d.time))
      .y0(y(0))
      .y1(d => yPersonal(d.handleTimePersonal))
      .curve(d3.curveMonotoneX);

    const svg = d3
      .select(id)
      .append('svg')
      .attr('width', width)
      .attr('height', height);

    svg
      .append('path')
      .datum(dataset)
      .attr('class', 'graph-secondary-area')
      .attr('d', avgTimeArea);

    svg
      .append('path')
      .datum(dataset)
      .attr('class', 'graph-primary-area')
      .attr('d', personalTimeArea);

    const tooltip = d3
      .select(id)
      .append('div')
      .attr('class', 'graph-tooltip')
      .style('opacity', 0);

    svg
      .selectAll('.graph-dot')
      .data(dataset)
      .enter()
      .append('circle')
      .attr('class', 'graph-dot')
      .attr('cx', (d, i) => x(d.time))
      .attr('cy', d => yPersonal(d.handleTimePersonal))
      .attr('r', 4)
      .on('mouseover', d => {
        tooltip
          .transition()
          .duration(200)
          .style('opacity', 0.9);
        tooltip.html(`
          <div class="graph-tooltip-primary">
              ${lbl1}: ${d.handleTimePersonal}
          </div>
          <div class="graph-tooltip-secondary">
              ${lbl2}: ${d.handleTimeAvg}
          </div>
        `);
      })
      .on('mouseout', d => {
        tooltip
          .transition()
          .duration(1000)
          .style('opacity', 0);
      });

    svg.append('g').call(xAxis);
  }
}
